const intialState = {
  Loading: false,
};

export default (state = intialState, action) => {
  switch (action.type) {
    case "Loading":
      return { ...state, Loading: action.payload };
    default:
      return state;
  }
};
